import { get_auth_and_redirect } from "@/api/auth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * This callback components gets the auth token from the backend if used with the Microsoft login
 * This is used to set the auth token in the Authorization header for all future requests until the user logs out
 */

export function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    const get_token = async () => {
      const code = new URLSearchParams(window.location.search).get('code');
      console.log("AuthCallback: Retrieved code from URL:", code);
      if (code) {
        const response = await get_auth_and_redirect(code);
        console.log("AuthCallback: Response from get_auth_and_redirect:", response);
        if (response.status === 200) {
          console.log("AuthCallback: Success! Navigating to /main_menu. Tokens should be stored.");
          navigate('/main_menu');
        } else {
          console.error("AuthCallback: Failed to get tokens. Status:", response.status, "Response:", response);
          navigate('/');
        }
      } else {
        console.warn("AuthCallback: No code found in URL. Navigating to /login.");
        navigate('/');
      }
    };
    get_token();

  }, [navigate]);

  return (
    <div>
      <p>Authenticating...</p>
    </div>
  );
}
